export const ATTENDANCE_VIEW_DESKTOP_HEADER_CLASS =
  "hidden md:flex sticky top-6 z-40 bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-lg border border-white/50 p-1.5 justify-between items-start xl:items-center gap-2 flex-wrap xl:flex-nowrap transition-all duration-300";

export const ATTENDANCE_VIEW_DESKTOP_GROUP_TOGGLE_WRAPPER_CLASS =
  "flex bg-gray-100/50 rounded-[2rem] p-1 border border-gray-200/60 shadow-inner flex-shrink-0 h-11 items-center gap-1";

export const ATTENDANCE_VIEW_DESKTOP_TAB_TOGGLE_WRAPPER_CLASS =
  "flex bg-gray-100/50 rounded-[2rem] p-1 border border-gray-200/60 shadow-inner w-auto flex-shrink-0 h-11 items-center gap-1";

export const ATTENDANCE_VIEW_DESKTOP_DATE_PICKER_WRAPPER_CLASS =
  "flex bg-gray-100/80 rounded-[2rem] p-1 border border-gray-200/50 shadow-inner flex-shrink-0 h-11 items-center";

export const ATTENDANCE_VIEW_DESKTOP_DATE_NAV_BUTTON_CLASS =
  "w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:shadow-sm transition";

export const ATTENDANCE_VIEW_DESKTOP_SEARCH_WRAPPER_CLASS =
  "relative group transition-all duration-300 w-40 min-w-0";

export const ATTENDANCE_VIEW_DESKTOP_SEARCH_ICON_CLASS = "absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 transition-colors";

export const ATTENDANCE_VIEW_DESKTOP_VIEW_MODE_WRAPPER_CLASS =
  "flex bg-white rounded-[2rem] p-[2px] border border-gray-200 shadow-sm flex-shrink-0 items-center h-11";

export const ATTENDANCE_VIEW_DAILY_LIST_CONTAINER_CLASS = "pb-24";

export const ATTENDANCE_VIEW_DAILY_LIST_GRID_CLASS = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2";

export const ATTENDANCE_VIEW_MONTHLY_MOBILE_LIST_CLASS = "flex flex-col gap-3 px-3 pt-2";

export const ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_CLASS =
  "bg-white rounded-[1.5rem] p-4 shadow-sm border border-gray-100 flex flex-col gap-3";

export const ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_HEAD_CLASS = "flex justify-between items-center";

export const ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_BODY_CLASS = "bg-gray-50 rounded-2xl p-3 flex justify-between items-center";

export const ATTENDANCE_VIEW_MONTHLY_MOBILE_DAY_ITEM_CLASS = "flex flex-col items-center gap-1.5";

export const ATTENDANCE_VIEW_MONTHLY_TABLE_CLASS = "w-full text-left border-collapse whitespace-nowrap";

export const ATTENDANCE_VIEW_MONTHLY_TABLE_HEAD_CLASS = "sticky top-0 z-20";

export const ATTENDANCE_VIEW_MONTHLY_TABLE_ROW_CLASS = "hover:bg-white/40 transition-colors group";

export const ATTENDANCE_VIEW_MONTHLY_TABLE_NAME_CELL_CLASS =
  "p-3 pl-6 sticky left-0 bg-white/80 backdrop-blur-md z-10 shadow-[4px_0_10px_-5px_rgba(0,0,0,0.05)] group-hover:bg-white/90 transition-colors rounded-l-2xl";

export const ATTENDANCE_VIEW_MONTHLY_TABLE_STATUS_CELL_CLASS = "p-2 text-center group-hover:bg-white/20 transition-colors";

export const ATTENDANCE_VIEW_MONTHLY_TABLE_RATE_CELL_CLASS = "p-3 text-center rounded-r-2xl";

export const ATTENDANCE_VIEW_YEARLY_CARD_HEAD_CLASS = "flex justify-between items-center mb-6";

export const ATTENDANCE_VIEW_YEARLY_MONTH_BAR_AREA_CLASS = "flex justify-between items-end h-24 gap-1.5 px-1 pb-1";

export const ATTENDANCE_VIEW_YEARLY_MONTH_ITEM_CLASS = "flex flex-col items-center gap-1.5 flex-1 cursor-pointer hover:opacity-80 transition";

export const ATTENDANCE_VIEW_YEARLY_MONTH_BAR_TRACK_CLASS = "w-full bg-gray-50 rounded-t-lg rounded-b-md h-full relative overflow-hidden flex items-end";

export const ATTENDANCE_VIEW_YEARLY_MONTH_LABEL_BASE_CLASS = "text-[9px] font-bold";

export function getAttendanceViewDesktopGroupButtonClass(isActive, themeBg) {
  return `px-5 h-9 rounded-[1.5rem] text-sm font-bold flex items-center justify-center ${isActive ? `${themeBg} text-white` : "text-gray-400 hover:text-gray-600 hover:bg-white/50"
    }`;
}

export function getAttendanceViewDesktopTabButtonClass(isActive, themeBg) {
  return `w-24 h-9 rounded-[1.5rem] text-xs font-bold flex items-center justify-center gap-1.5 ${isActive ? `${themeBg} text-white` : "text-gray-400 hover:text-gray-600 hover:bg-white/50"
    }`;
}

export function getAttendanceViewDesktopSearchInputClass(theme) {
  return `w-full pl-10 pr-4 h-11 border border-gray-200 rounded-[2rem] text-xs bg-white focus:bg-white focus:outline-none focus:${theme.border} focus:ring-1 focus:ring-${theme.bg.replace(
    "bg-",
    ""
  )}/20 transition font-bold shadow-sm`;
}

export function getAttendanceViewDesktopSearchIconFocusClass(themeTextClass) {
  return `group-focus-within:${themeTextClass}`;
}

export function getAttendanceViewDesktopViewModeButtonClass(isActive, theme) {
  return `w-11 h-11 rounded-full transition-all border border-transparent flex items-center justify-center ${isActive
      ? `${theme.lightBg} ${theme.text} ${theme.border.replace("border-", "border-").replace("]", "]/20")}`
      : "text-gray-400 hover:text-gray-600"
    }`;
}

export function getAttendanceViewDailyListRowClass(isSelected, brand) {
  return `group bg-white rounded-[1.2rem] p-2 flex items-center gap-2 border transition-all duration-200 cursor-pointer hover:shadow-md ${isSelected
      ? `${brand.primaryBorderSolidClass} ring-2 ${brand.primaryRingSoftClass} ${brand.primaryBgSoftClass}`
      : "border-gray-100 hover:border-gray-200"
    }`;
}

export function getAttendanceViewDailyListCheckboxClass(isSelected, brand) {
  return `w-5 h-5 rounded-lg border-2 flex-shrink-0 flex items-center justify-center transition-colors ${isSelected ? `${brand.primaryBgClass} ${brand.primaryBorderSolidClass}` : "border-gray-200 group-hover:border-gray-300 bg-white"
    }`;
}

export function getAttendanceViewDailyListStatusButtonClass(currentStatus, targetStatus) {
  if (targetStatus === "present") {
    return `w-7 h-7 rounded-xl flex items-center justify-center transition-all ${currentStatus === "present"
        ? "bg-emerald-500 text-white shadow-md shadow-emerald-500/20"
        : "bg-gray-50 text-gray-300 hover:bg-emerald-50 hover:text-emerald-500"
      }`;
  }
  if (targetStatus === "late") {
    return `w-7 h-7 rounded-xl flex items-center justify-center transition-all ${currentStatus === "late"
        ? "bg-amber-400 text-white shadow-md shadow-amber-400/20"
        : "bg-gray-50 text-gray-300 hover:bg-amber-50 hover:text-amber-500"
      }`;
  }
  return `w-7 h-7 rounded-xl flex items-center justify-center transition-all ${currentStatus === "absent"
      ? "bg-rose-500 text-white shadow-md shadow-rose-500/20"
      : "bg-gray-50 text-gray-300 hover:bg-rose-50 hover:text-rose-500"
    }`;
}

export function getAttendanceViewDailyListStatusDotClass(currentStatus, targetStatus) {
  return `w-2 h-2 rounded-full ${currentStatus === targetStatus ? "bg-white" : "bg-current"
    }`;
}

export function getAttendanceViewRateBadgeClass(rate) {
  if (rate >= 80) return "text-xs font-black px-2.5 py-1 rounded-lg bg-emerald-100 text-emerald-700";
  if (rate >= 50) return "text-xs font-black px-2.5 py-1 rounded-lg bg-yellow-100 text-yellow-700";
  return "text-xs font-black px-2.5 py-1 rounded-lg bg-rose-100 text-rose-700";
}

export function getAttendanceViewMonthlySmallStatusIconClass(status) {
  if (status === "present") return "w-7 h-7 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 shadow-sm";
  if (status === "late") return "w-7 h-7 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 shadow-sm";
  if (status === "absent") return "w-7 h-7 rounded-full bg-rose-100 flex items-center justify-center text-rose-500 shadow-sm";
  return "w-2 h-2 bg-gray-200 rounded-full my-2.5";
}

export function getAttendanceViewMonthlyTableStatusIconClass(status) {
  if (status === "present") return "w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 shadow-sm";
  if (status === "late") return "w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 shadow-sm";
  if (status === "absent") return "w-8 h-8 rounded-full bg-rose-100 flex items-center justify-center text-rose-500 shadow-sm";
  return "w-2 h-2 bg-gray-200 rounded-full";
}

export function getAttendanceViewYearlyGridClass(isMobile) {
  return `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${isMobile ? "gap-3 px-3 pt-2" : "gap-5"}`;
}

export function getAttendanceViewYearlyCardClass(isMobile) {
  return `bg-white border border-gray-100 shadow-[0_4px_20px_-10px_rgba(0,0,0,0.05)] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group ${isMobile ? "p-4 rounded-[1.5rem]" : "p-6 rounded-[2rem]"
    }`;
}

export function getAttendanceViewYearlyAvgTextClass(avg) {
  if (avg >= 80) return "text-xl font-black text-emerald-500";
  if (avg >= 50) return "text-xl font-black text-amber-500";
  return "text-xl font-black text-rose-500";
}

export function getAttendanceViewYearlyBarTheme(rate) {
  if (rate >= 80) return { barColor: "bg-emerald-400 group-hover:bg-emerald-500", textColor: "text-emerald-600" };
  if (rate >= 50) return { barColor: "bg-amber-300 group-hover:bg-amber-400", textColor: "text-amber-600" };
  if (rate > 0) return { barColor: "bg-rose-300 group-hover:bg-rose-400", textColor: "text-rose-600" };
  return { barColor: "bg-gray-100", textColor: "text-gray-300" };
}
